import webStorageKeys from '@/constants/web-storage-keys';
import { ViewEnum } from '@/types';

// TODO: 可考慮將各頁面分開儲存的 storage 合併為單一佇列, 統一用 push & pop 控制導轉
/** 依當前頁面取得對應的 sessionStorage key */
const getPageStorageKey = (pathName: string) => {
	pathName = pathName.startsWith('/bets') ? '/bets' : pathName;
	switch (pathName.split('?')[0]) {
		case '/message':
			return webStorageKeys.ROUTER_MESSAGE_BACK;
		case '/bets':
			return webStorageKeys.ROUTER_MY_BETS_BACK;
		case '/account/history':
			return webStorageKeys.ROUTER_HISTORY_BACK;
		case '/results':
			return webStorageKeys.ROUTER_RESULT_BACK;
		case '/how-to-use':
			return webStorageKeys.ROUTER_HOW_TO_USE_BACK;
		case '/footer/contact-info':
			return webStorageKeys.ROUTER_CONTACT_US_BACK;
		default:
			return webStorageKeys.ROUTER_COMMON_BACK;
	}
}

/**
 * 客製化導轉 - 記憶當前路由並前往下一頁
 * @param redirect router.push
 * @param locale locale (options param of router.push)
 * @param to next path
 * @param from current path
 */
const push = (redirect: any, locale: string, to: string, from?: string) => {
	const storageKey = getPageStorageKey(to);

	if (storageKey && from) {
		sessionStorage.setItem(storageKey, from);
	}

	redirect(to, { locale });
}

/**
 * 客製化導轉 - 依記憶路由返回上一頁
 * @param redirect router.push
 * @param locale locale (options param of router.push)
 * @param from current path
 * @param view current view
 */
const pop = (redirect: any, locale: string, from: string, view: ViewEnum) => {
	const storageKey = getPageStorageKey(from);
	const previousPage = getPreviousPage(from);
	if (previousPage) {
		sessionStorage.removeItem(storageKey);
	}

	const defaultPage = view === ViewEnum.galaxy ? '/live/1' : '/sports/1';
	redirect(previousPage || defaultPage, { locale });
}

const getPreviousPage = (from: string) => {
	const storageKey = getPageStorageKey(from);
	return storageKey ? sessionStorage.getItem(storageKey) : '';
}

const checkCanBack = (from: string) => getPreviousPage(from) ? true : false;

export const routerService = {
	push,
	pop,
	checkCanBack
};